import { FC } from 'react';

import closeIcon from 'assets/icons/close.svg?url';

import { Button, Icon } from './CloseButton.styles';

interface CloseButtonProps {
  onClick: () => void;
  className?: string;
}

export const CloseButton: FC<CloseButtonProps> = ({ onClick, className }) => (
  <Button onClick={onClick} className={className}>
    <Icon src={closeIcon} alt="" />
  </Button>
);
